import { ControllerAlert, ControllerAlertProps } from '@bymason-private/legacy-pattern-components';
import { useCheckFeatureFlag } from '../../global-state';

export default function GlobalStatusAlert(props: ControllerAlertProps) {
  const [isAlertEnabled, alertBody] = useCheckFeatureFlag('controller-alert');

  return isAlertEnabled ? (
    <ControllerAlert severity='warning' variant='outlined' {...props}>
      {alertBody}
    </ControllerAlert>
  ) : null;
}
